<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper building" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal building">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div class="contentHeader unselectable">
							<div>
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>Тайник</span></span>
									<span class="level">
										(<span><span>Уровень {{gameModel.island.buildings.cache.level}}</span></span>)
									</span>
								</h2>
								<div class="buildingDescription">
									<span>При набеге на твой остров ее жители прячут в тайник часть сырья из хранилищ. Это сырье не может быть украдено нападающими.</span>
								</div>
								<img class="buildingHuge buildingType23 tribeId3 level5" src="//iwstatic.g.bsrv.su/img/x.gif" />
							</div>
							<span class="buildingStatusButton type_15">
								<div class="buildingStatus location27 optionMenu">
									<div class="buildingBubble clickable disabledHover">
										<div class="colorLayer notNow enoughRes">
											<div class="labelLayer">
												<span class="buildingLevel">5</span>
											</div>
										</div>
									</div>
								</div>
							</span>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
							<div class="contentTabulation">
								<div class="tabulationContent scrollable tabContent">
									<div class="scrollContentOuterWrapper">
										<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div ng-transclude="">
														<div ng-controller="buildingIndexCtrl" class="building buildingType23" ng-class="{buildingResourceProduction: building.data.buildingType <= 4}">
															<div ng-include="" src="pageTemplate"><div class="buildingDetails">
																<div ng-include="" src="'tpl/building/partials/buildingInformationEffects.html'">
																	<div class="contentBox gradient buildingEffect" ng-if="currentEffect.values[0] != undefined && (building.data.lvl > 0 || building.data.buildingType <= 4 || building.data.buildingType == 42)">
																		<h6 class="contentBoxHeader headerColored">
																			<span translate="" options="23" data="lvl: , value: "><span>Тайник</span></span>
																		</h6>
																		<div class="contentBoxBody">
																			<div class="current">
																				<h6 class="headerTrapezoidal">
																					<div class="content" translate=""><span>Сейчас</span></div>
																				</h6>
																				<div class="currentLevel" data="lvl: 1" translate=""><span>Уровень 1</span></div>
																				<div class="value">
																					200
																				</div>
																				<div class="unit" options="23" translate=""><span>Единиц каждого ресурса</span></div>
																			</div>
																			<div class="nextLvl">
																				<h6 class="headerTrapezoidal">
																					<div class="content" translate=""><span>Следующие уровни</span></div>
																				</h6>
																				<table ng-repeat="effect in nextEffects" ng-class="{}" class="transparent">
																					<tbody>
																						<tr ng-class="{upgrading: building.data.lvlNext > getFutureLevel($index)}">
																							<th>2</th>
																							<td>
																								<span translate="" options="23" data="value:260"><span>260 ед. каждого ресурса</span></span>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																				<table ng-repeat="effect in nextEffects" ng-class="{}" class="transparent">
																					<tbody>
																						<tr ng-class="{upgrading: building.data.lvlNext > getFutureLevel($index)}">
																							<th>3</th>
																							<td>
																								<span translate="" options="23" data="value:340"><span>340 ед. каждого ресурса</span></span>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																				<table ng-repeat="effect in nextEffects" ng-class="{}" class="transparent">
																					<tbody>
																						<tr ng-class="{upgrading: building.data.lvlNext > getFutureLevel($index)}">
																							<th>4</th>
																							<td>
																								<span translate="" options="23" data="value:440"><span>440 ед. каждого ресурса</span></span>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																				<table ng-repeat="effect in nextEffects" ng-class="{}" class="transparent">
																					<tbody>
																						<tr ng-class="{upgrading: building.data.lvlNext > getFutureLevel($index)}">
																							<th>5</th>
																							<td>
																								<span translate="" options="23" data="value:560"><span>560 ед. каждого ресурса</span></span>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																				<table ng-repeat="effect in nextEffects" ng-class="{}" class="transparent">
																					<tbody>
																						<tr ng-class="{upgrading: building.data.lvlNext > getFutureLevel($index)}">
																							<th>6</th>
																							<td>
																								<span translate="" options="23" data="value:720"><span>720 ед. каждого ресурса</span></span>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																				<table ng-repeat="effect in nextEffects" ng-class="{}" class="transparent">
																					<tbody>
																						<tr ng-class="{upgrading: building.data.lvlNext > getFutureLevel($index)}">
																							<th>7</th>
																							<td>
																								<span translate="" options="23" data="value:920"><span>920 ед. каждого ресурса</span></span>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</div>
																		</div>
																	</div>
																</div>
																<div class="buildingEffect allInVillage contentBox gradient" ng-controller="crannyCtrl">
																	<h6 class="contentBoxHeader headerWithIcon arrowDirectionTo">
																		<i class="empty"></i>
																		<span translate=""><span>Тайники в этой деревне</span></span>
																	</h6>
																	<div class="contentBoxBody">
																		<div class="capacity">
																			<h6 class="headerTrapezoidal">
																				<div class="content" translate=""><span>Вместимость</span></div>
																			</h6>
																			<div class="value" data="value: 200" options="23" translate=""><span>&#x202D;&#x202D;200&#x202C;&#x202C;</span></div>
																			<div class="unit" options="23" translate=""><span>Единиц каждого ресурса</span></div>
																		</div>
																		<div class="lootableResources">
																			<h6 class="headerTrapezoidal">
																				<div class="content" translate=""><span>Ресурсы, которые можно украсть</span></div>
																			</h6>
																			<div class="resourceWrapper">
																				<div class="resource" ng-repeat="(key, resource) in lootableResources" ng-if="!config.balancing.specialRules.cropDiet || key != 4">
																					<i class="unit_wood_medium_illu"></i>
																					<span ng-if="resource.value <= 0">0</span>
																				</div>
																				<div class="resource" ng-repeat="(key, resource) in lootableResources" ng-if="!config.balancing.specialRules.cropDiet || key != 4">
																					<i class="unit_clay_medium_illu"></i>
																					<span class="lootable" ng-if="resource.value > 0">166</span>
																				</div>
																				<div class="resource" ng-repeat="(key, resource) in lootableResources" ng-if="!config.balancing.specialRules.cropDiet || key != 4">
																					<i class="unit_iron_medium_illu"></i>
																					<span class="lootable" ng-if="resource.value > 0">205</span>
																				</div>
																				<div class="resource" ng-repeat="(key, resource) in lootableResources" ng-if="!config.balancing.specialRules.cropDiet || key != 4">
																					<i class="unit_crop_medium_illu"></i>
																					<span class="lootable" ng-if="resource.value > 0">509</span>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Тайник | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		villageBackgroundLeft: '0px',
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
	},
	unmounted(){
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	created(){
		this.gameModel.buildingQueue.show = true;
	},
	components: {},
}
</script>